"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invariantColors = void 0;
exports.invariantColors = {
    invariantWhite: "#FFFFFF",
    invariantBlack: "#000000"
};
